export const featureFlagSlugs = {
  transportMagicLinkLogin: 'transport_magic_link_login',
  pricePerMile: 'load_board_price_per_mile',
  instantBook: 'transport_instant_book',
  transportTms: 'transport_carrier_preferred_tms',
  mobileImprovementManage: 'load_board_mobile_improvement_manage',
  mobileImprovementNavigation: 'load_board_mobile_improvement_navigation',
  mobileImprovementJobcard: 'load_board_mobile_improvement_jobcard',
  mobileImprovementFilter: 'load_board_mobile_improvement_filter',
  mobileImprovementCarrierProfile: 'load_board_mobile_improvement_carrier_profile'
};
